import Vue from 'vue'
import App from './App.vue'
import router from "./router";

// 引用
import ElementUI from 'element-ui';
import 'element-ui/lib/theme-chalk/index.css';
Vue.use(ElementUI);

// 公用样式
import "@/assets/styles/index.css";
import "@/assets/styles/size.css";
import "@/assets/styles/background.css";
import "@/assets/styles/margin.css";
import "@/assets/styles/padding.css";
import "@/assets/styles/flex.css";

// 状态
import Vuex from 'vuex'
Vue.use(Vuex)
import store from "./store/index";


// 分页
Vue.prototype.$pageSizes = [7, 10, 20, 30]
Vue.prototype.$pageSizes2 = [10, 20, 30, 40]

// 富文本
import VueUeditorWrap from "vue-ueditor-wrap";
Vue.component("vue-ueditor-wrap", VueUeditorWrap);
Vue.prototype.$editorConfig = {
  // 访问 UEditor 静态资源的根路径，可参考 https://hc199421.gitee.io/vue-ueditor-wrap/#/faq
  UEDITOR_HOME_URL: "https://xz.xzdjy.com/UEditor/",
  // 服务端接口（这个地址是我为了方便各位体验文件上传功能搭建的临时接口，请勿在生产环境使用！！！）
  serverUrl: "//ueditor.szcloudplus.com/cos",
  toolbars: [
    [
      "source",
      "|",
      "undo",
      "redo",
      "|",
      "bold",
      "italic",
      "underline",
      "removeformat",
      "|",
      'justifyleft',
      'justifycenter',
      'justifyright',
      'justifyjustify',
      "|",
      "forecolor",
      "backcolor",
      "insertorderedlist",
      "insertunorderedlist",
      "fontfamily",
      "fontsize",
    ],
  ],
  elementPathEnabled: false,
  wordCount: false,
  initialFrameHeight: 250,
  initialFrameWidth: '100%',
},

  Vue.config.productionTip = false

new Vue({
  router,
  store,
  render: h => h(App),
}).$mount('#app')
